import type { CSSProperties } from 'react'

// Cor padronizada dos agentes (feedback do fundador, jul/2026): TODOS os agentes
// usam a MESMA cor — o matiz da marca — em vez de um matiz por-agente. Antes
// cada agente tinha um --agent-hue derivado do id (hash FNV-1a); o fundador não
// gostou e pediu para padronizar. Mantemos as assinaturas (seed) para não tocar
// nos ~12 call sites; o valor é fixo (= fallback --agent-hue do design-tokens).
const STANDARD_AGENT_HUE = 292

/**
 * Matiz da cor de um agente. Padronizado: ignora o seed e devolve sempre o
 * matiz da marca (todos os agentes iguais). O parâmetro segue na assinatura só
 * por compatibilidade com os call sites.
 */
export function agentHue(_seed: string): number {
  return STANDARD_AGENT_HUE
}

/**
 * Style para aplicar o matiz do agente numa subárvore. Padronizado no matiz da
 * marca; `bg-agent` / `text-agent` / `--agent` resolvem igual para todo agente.
 */
export function agentHueStyle(_seed: string): CSSProperties {
  return { '--agent-hue': STANDARD_AGENT_HUE } as CSSProperties
}
